import GLOBAL from '../util/global';
import { match } from '../util/utils';
import generateUUID from '../util/uuid';
import postXHR from '../util/xhr';

import IAjax from '../core/types/ajax.type';
import Category from '../core/types/category.type';
import { LogLevel } from '../core/types/log.type';
import IMessage, { IShared } from '../core/types/message.type';

let FORMER_XHR_FLAG: boolean = true;
const INTERVAL_SECONDS: number = 2; // timer发送间隔（秒）
const INTERVAL_SECONDS_LIMIT: number = 1; // ajax相隔阈值(毫秒)

const xhrSharedAttrs: string[] = ['network', 'pageId', 'pageUrl'];
let xhrSharedData: any = null;

let sendIntervalObj: any = null;
let lastTimestamp: number = 0;

const ajaxSendIdList: any = {}; // 页面发送的ajax id
let ajaxSendList: IMessage[] = []; // 页面发送的ajax队列
let sharedData: IShared[] = [];

function sendLogs(ctx: any): void {
    let mergedData: IMessage[] = [];
    mergedData = mergedData.concat(ajaxSendList);
    ajaxSendList = [];

    // 每次发送完全部数据后清除interval
    if (sendIntervalObj !== null) {
        GLOBAL.clearInterval(sendIntervalObj);
        sendIntervalObj = null;
    }

    if (mergedData.length === 0) {
        return;
    }

    xhrSharedData = ctx.getCustom(xhrSharedAttrs);

    const postData = [{
        common: Object.assign({ category: Category.AJAX }, sharedData, xhrSharedData),
        body: mergedData,
    }];

    postXHR({
        data: encodeURIComponent(JSON.stringify(postData)),
    });
}

function _xhrRuntime(ctx: any): void {
    const xhr: any = GLOBAL.XMLHttpRequest;
    const xhrSend: any = xhr.prototype.send;
    const xhrOpen: any = xhr.prototype.open;

    xhr.prototype.open = function(method: string, url: string) {
        if (ctx.core.ignore.xhr.length > 0 && match(url, ctx.core.ignore.xhr) === false) {
            const id = generateUUID(6);
            ajaxSendIdList[id] = url;
            this.prajnaId = id;
            this.prajnaMethod = method.toUpperCase();
            this.prajnaUnix = Date.now();
        }
        return xhrOpen.apply(this, arguments);
    };

    xhr.prototype.send = function(sendData: any) {

        if (this.prajnaId) {
            const xhrInstance: IAjax = {
                resourceUrl: '',
                status: 0,
                requestmethod: this.prajnaMethod,
                responsetime: 0,
            };

            this.addEventListener('readystatechange', function() {
                switch (this.readyState) {
                    case 1: // OPENED
                    case 2: // HEADERS_RECEIVED
                    case 3: // LOADING
                        break;
                    case 4: // DONE
                        xhrInstance.status = this.status;
                        xhrInstance.responsetime = +new Date() - this.prajnaUnix; // - xhrInstance.responsetime?

                        // if httpcode is 302: status ==== 0 and this.responseURL can't be got.
                        if (!this.responseURL) {
                            xhrInstance.resourceUrl = ajaxSendIdList[this.prajnaId];
                        } else {
                            xhrInstance.resourceUrl = this.responseURL;
                        }

                        const raw: IMessage = ctx.inspect(xhrSharedAttrs);

                        // if cors fail or 404 or 302: status === 0
                        if (xhrInstance.status === 0 || xhrInstance.status >= 400) {
                            ctx.core.emit(LogLevel.ERROR);
                            xhrInstance.requestbody = sendData;
                        }

                        raw.xhr = xhrInstance;

                        ajaxSendList.push(raw);
                        delete ajaxSendIdList[this.prajnaId];

                        const newTimestamp = Date.now();

                        // 当前的ajax的间隔较大直接发送；间隔小合并发送
                        if (newTimestamp - lastTimestamp > INTERVAL_SECONDS_LIMIT * 1000) {
                            sendLogs(ctx);
                        } else {
                            if (sendIntervalObj === null) {
                                sendIntervalObj = GLOBAL.setInterval(() => {
                                    sendLogs(ctx);
                                }, INTERVAL_SECONDS * 1000);
                            }
                        }
                        lastTimestamp = newTimestamp;
                        break;
                    default:
                        break;
                }
            });
        }

        return xhrSend.apply(this, arguments);
    };

    // 离开页面
    GLOBAL.addEventListener("beforeunload", () => {
        sendLogs(ctx);
    });
}

function AjaxMiddleware(ctx: any, next: any): any {
    if (FORMER_XHR_FLAG) {
        FORMER_XHR_FLAG = false;
        sharedData = ctx.getShared();
        _xhrRuntime(ctx);
    }
    next();
}

export default AjaxMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/ajax-middleware.ts